// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3tckZ","selects":"Documents_selects__3MmIQ"};